<template>
  <div>
    <el-table :data="items">
      <el-table-column
        align="center"
        label="材料名称"
        prop="name"
      ></el-table-column>
      <el-table-column
        align="center"
        label="存货编码"
        prop="code"
      ></el-table-column>
      <el-table-column
        align="center"
        label="规格"
        prop="specification"
      ></el-table-column>
      <el-table-column
        :label="category == 2 ? '倒角' : '型号'"
        prop="model_number"
        align="center"
      >
      </el-table-column>
      <template v-if="category == 2">
        <el-table-column label="齿形" prop="tooth_type" align="center">
        </el-table-column>
        <el-table-column label="尺寸" prop="size" align="center">
        </el-table-column>
      </template>
      <el-table-column
        align="center"
        label="单位"
        prop="unit"
      ></el-table-column>
      <el-table-column align="center" label="期初数量（价格）">
        <template slot-scope="scope">
          {{ scope.row.beginning_count }}（{{
            scope.row.beginning_price.toFixed(2)
          }}）
        </template>
      </el-table-column>
      <el-table-column align="center" label="当前数量（新/旧）" prop="number">
        <template slot-scope="scope">
          {{ scope.row.number }} | {{ scope.row.old_number }}
        </template>
      </el-table-column>
      <el-table-column label="仓库" align="center" prop="stockroom.name">
      </el-table-column>
      <el-table-column label="操作" align="center" width="120">
        <template slot-scope="scope">
          <!-- <btn-tag
            v-if="currentUser.id == scope.row.stockroom.user_id"
            :btn="true"
            :auth-id="51301"
            text="编辑"
            :key="Math.random()"
            module-name="stock"
            @click.native="editItem(scope.row, scope.$index)"
          ></btn-tag> -->
          <btn-tag
            :btn="true"
            :auth-id="51301"
            text="详情"
            :key="Math.random()"
            module-name="stock"
            @click.native="handleShow(scope.row)"
          ></btn-tag>
          <!-- <btn-tag
            :btn="true"
            text="删除"
            :key="Math.random()"
            btn-class="btn-danger"
            icon-class="ion-trash-b"
            module-name="orders"
            @click.native="hanldeDelte(scope.row, scope.$index)"
          ></btn-tag> -->
        </template>
      </el-table-column>
    </el-table>
    <item-former
      :model="model"
      :show.sync="formerVisible"
      @updated="updatedCallback"
    ></item-former>
    <item-detail :model="model" :show.sync="detailVisible"></item-detail>
  </div>
</template>

<script>
import { itemDelete } from '@/service/getData'
import ItemFormer from '@/components/item_former'
import ItemDetail from '@/components/item_detail'
import { deepClone } from '@/utils'
import { getStore } from '@/config/mUtils'

export default {
  components: {
    ItemFormer,
    ItemDetail,
  },
  props: {
    items: null,
    admin: false,
    category: Number,
  },
  data() {
    return {
      currentUser: getStore('userInfo'),
      model: {},
      formerVisible: false,
      detailVisible: false,
      editIndex: 0,
    }
  },
  methods: {
    editItem(item, index) {
      this.model = deepClone(item)
      this.editIndex = index
      this.formerVisible = true
    },
    handleShow(item) {
      this.model = item
      this.detailVisible = true
    },
    updatedCallback(data) {
      this.$set(this.items, this.editIndex, data)
    },
    hanldeDelte(item, index) {
      let that = this
      that.$dialog.confirm('确认删除吗').then(function (dialog) {
        itemDelete(item.id).then((res) => {
          if (res.status == 0) {
            that.items.splice(index, 1)
          }
        })
      })
    },
  },
}
</script>